export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-foreground-300">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-lg text-white"></i>
              </span>
              <span className="text-xl font-heading text-white">菲菲影院</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              菲菲影院致力于为广大影迷提供最新高清电影、高分动作片、喜剧片免费在线观看服务，海量电影资源每日更新，流畅不缓冲，随时随地享受观影乐趣。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '精彩专题', href: '#index' },
                { label: '精选预告', href: '#media' },
                { label: '常见问答', href: '#faq' },
                { label: '热门话题', href: '#topics' },
                { label: '焦点专题', href: '#carousel' },
                { label: '最新快讯', href: '#updates' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">电影分类</h4>
            <div className="flex flex-col gap-2">
              {['动作片', '喜剧片', '科幻片', '悬疑片', '爱情片', '动画片'].map((cat) => (
                <span key={cat} className="text-sm text-foreground-400 whitespace-nowrap">{cat}</span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-white mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500">优质合作伙伴持续入驻中</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 菲菲影院 - 电影大全免费在线观看。本站内容仅供学习交流，请支持正版。
          </p>
          <div className="flex items-center gap-5">
            <span className="text-xs text-foreground-500 whitespace-nowrap">关于我们</span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">隐私政策</span>
            <span className="text-xs text-foreground-500 whitespace-nowrap">服务条款</span>
          </div>
        </div>
      </div>
    </footer>
  );
}